import { Outlet, useMatches, useParams } from 'react-router'

import { RouteHandle } from '@/@types/routes'
import { CompanyBreadcrumbs } from '@/components/breadcrumbs'
import { Header } from '@/components/header'
import { Sidebar } from '@/components/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'

import { useMenuItems } from './menu-items'

export function CompanyLayout() {
  const matches = useMatches()
  const currentHandle = matches.at(-1)?.handle as RouteHandle

  const { companyId } = useParams()

  const menuItems = useMenuItems()

  return (
    <div className="relative flex h-screen flex-col bg-studio-image bg-cover bg-center bg-no-repeat antialiased">
      <TooltipProvider>
        <Header>
          <Header.Breadcrumbs>
            <CompanyBreadcrumbs />
          </Header.Breadcrumbs>

          {currentHandle?.action && (
            <Header.Action>{currentHandle.action}</Header.Action>
          )}
        </Header>

        <div className="flex min-h-0 flex-1">
          <Sidebar menuItems={menuItems} />

          <main className="h-full w-full select-none overflow-hidden p-4">
            <Outlet key={companyId} />
          </main>
        </div>
      </TooltipProvider>
    </div>
  )
}
